/**
 * Collection-specific product card images.
 *
 * Some product cards (e.g. those rendered by Nosto via the Section Rendering API
 * against a product URL) are produced without the current collection in scope, so
 * the Liquid-side override in snippets/card-product.liquid cannot run. For those,
 * the snippet emits a `data-collection-specific-images` attribute holding a
 * { "<collection-handle>": "<image-url>" } map. This script reads the collection
 * handle from the current URL and swaps the card image in the browser, where the
 * collection being viewed IS known.
 *
 * Native collection grids are already handled server-side; running here again is
 * idempotent (it would set the same image), so this is safe on every PLP.
 */
(function () {
  'use strict';

  var ATTR = 'data-collection-specific-images';
  var DONE = 'data-csi-applied';
  var WIDTHS = [250, 350, 450, 750, 900, 1100, 1500];

  function currentCollectionHandle() {
    var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function withWidth(url, width) {
    if (/[?&]width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, '$1width=' + width);
    }
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function buildSrcset(url) {
    return WIDTHS.map(function (width) {
      return withWidth(url, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function applyToImg(img, handle) {
    if (!img || img.getAttribute(DONE) === handle) return;

    var raw = img.getAttribute(ATTR);
    if (!raw) return;

    var map;
    try {
      map = JSON.parse(raw);
    } catch (error) {
      return;
    }

    var url = map && map[handle];
    if (!url) return;

    img.srcset = buildSrcset(url);
    img.src = withWidth(url, 1500);
    img.setAttribute(DONE, handle);
  }

  function run(root) {
    var handle = currentCollectionHandle();
    if (!handle) return;

    if (root && root.nodeType === 1 && root.matches && root.matches('img[' + ATTR + ']')) {
      applyToImg(root, handle);
    }

    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('img[' + ATTR + ']').forEach(function (img) {
      applyToImg(img, handle);
    });
  }

  function observe() {
    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (
            (node.matches && node.matches('img[' + ATTR + ']')) ||
            (node.querySelector && node.querySelector('img[' + ATTR + ']'))
          ) {
            run(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    run(document);
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
